import instance from '@/utils/instance';

//获取所有新闻列表
export function getNewsList(params) {
    return instance({
        url: `/webL_api/essential/api/queryNewsInfo?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
        method: 'post',
        data: params
    });
}

//获取新闻详情
export function getNewsDetail(params) {
    return instance({
        url: `/webL_api/essential/api/newInfo/${params}`,
        method: 'get',
    });
}
